<script>
import table from './providers.table'
import getExportedFilename from '@lib/utils/get-exported-filename'
import { mapGetters } from 'vuex'

export default {
  name: 'Providers',
  page: {
    title: 'Providers',
  },
  data: function() {
    return {
      table: table(this),
    }
  },
  computed: {
    ...mapGetters('me', [
      'canCreateProvider',
    ]),
  },
  methods: {
    handleClick() {
      this.$router.push({
        name: 'provider-create',
      })
    },
    onRowClick(item) {
      this.$router.push({
        name: 'provider-update',
        params: { id: item.id || 'unknown' },
      })
    },
    getExportedFilename() {
      return getExportedFilename(this.table.tableName)
    },
  },
}
</script>

<template>
  <main-layout title="Providers">
    <template slot="header">
      <el-button
        v-if="canCreateProvider"
        type="primary"
        icon="el-icon-plus"
        plain
        @click="handleClick"
      >
        Add New Provider
      </el-button>
    </template>
    <table-layout
      :table-name="table.tableName"
      :processor="table.processor"
      :filters="table.filters"
      :columns="table.columns"
      :fragments="false"
      :quantity="[25, 50, 100, 200]"
      :export-filename="getExportedFilename"
      :multisort="false"
      hider-header-visible
      @row-click="onRowClick"
    />
  </main-layout>
</template>
